export enum OptimizelyExperiments {
  isSupportAssistantEnabled = 'opex_support_assistant_customer_pool',
  lereSearchModelV4 = 'lere_search_model_v4',
  emailChangeEnabled = 'opex_email_change',
  refundProtectForInternationalEnabled = 'cro_refund_protect_vs_insurance_international',
  offerPageSecondChanceModal = 'offer_page_second_chance_modal',
  searchPageSecondChanceModal = 'search_page_second_chance_modal',
  specificPaidLandingPage = 'specific_paid_landing_page',
  croMultiItemCart = 'cro_multi_item_cart',
  securePhoneNumberChangeEnabled = 'csx_secure_phone_number_change',
  croLPFreePreviewAfterSignUpLogIn = 'cro_offer_lp_free_preview_after_sign_up_log_in',
  croAlwaysOnNewMobileBooking = 'cro_lpc_new_mobile_booking',
  croFlexibleFlightFares = 'cro_flexible_flight_fares',
  paymentsDepositOptionForHotelsAbove1999V2 = 'payments_deposit_option_for_hotels_above_1999_v2',
  carHireBundledDiscountUpcomingOrderHomepageCarousel = 'car_hire_bundled_discount_upcoming_order_homepage_carousel',
  croStickyWalledGarden = 'cro_sticky_walled_garden',
  croPopularOptionBookingRemaining = 'cro_popular_option_booking_remaining',
  croDreamBlocksOnOfferPages = 'cro_dream_blocks_on_offer_pages',
  searchRankingValueTestExpanded = 'search_ranking_value_test_expanded',
  growthShowOfferUrgencyCountdownLabel = 'growth_force_show_offer_urgency_countdown_label',
  croBundledFlexibleFlightFaresV2 = 'cro_bundled_flexible_flight_fares_v2',
  lereFilterLowMpvCarousel = 'lere_filter_low_mpv_carousel_2',
  paymentsPaypalButtonOrder = 'payments_paypal_button_order',
  searchMpvSalesRanking2 = 'search_mpv_sales_ranking_2',
  isCfmrEnabledForInternationalHotels = 'cro_cfmr_vs_insurance_for_international_hotels',
  croDisableKrisFlyer = 'cro_disable_krisflyer',
  croHideHomepageSearchEmergingMarkets = 'cro_hide_homepage_search_emerging_markets',
}

export enum OptimizelyFeatureFlags {
  luxLoyaltyFeatureToggle = 'lux_loyalty_feature_toggle',
  luxPlusFeatureToggle = 'luxplus_feature_toggle',
  luxPlusToursToggle = 'luxplus_tours_toggle',
  luxPlusDiscountedInsuranceBenefit = 'lux_plus_discounted_insurance_benefit',
  luxPlusDiscountedBookingProtectionBenefit = 'lux_plus_discounted_booking_protection_benefit',
  luxPlusLppPricingEnabled = 'luxplus_lpp_pricing_enabled',
  luxPlusCruiseInclusionsEnabled = 'lux_plus_cruise_inclusions',
  luxPlusDiscountedExperiencesBenefit = 'lux_plus_discounted_experiences_benefit',
  allowPhoneNumberLogin = 'allow_phone_number_login',
  promoAppBanner = 'app_banner_targeted_delivery',
  CSAgentsAutoQuote = 'cro_cs_agents_auto_quote',
  tourReviewsEnabled = 'cro_tour_reviews',
  toursRequestAgentCallbackEnabled = 'csx_tours_request_agent_callback',
  hotelsAndVillasRequestAgentCallbackEnabled = 'csx_hotels_and_villas_request_agent_callback',
  upsellTilesFeatureToggle = 'cro_upsell_on_homepage_and_my_escapes',
  croNewFlightsSaleCarouselEnabled = 'cro_flights_sale_carousel',
  croTravelPreferencesModalEnabled = 'cro_travel_preferences_modal',
  opexTermsAndConditionsModal = 'terms_and_conditions_modal',
  lebtPinnedFlightDetails = 'lebt_pinned_flight_details',
  croWebPushNotificationPrompt = 'cro_web_push_notification_prompt',
  opexFraudOrdersOtp = 'opex_fraud_orders_otp',
  lebtMerchantFeesEnabled = 'lebt_merchant_fees',
  payIdTargetedRelease = 'pay_id_targeted_release',
  accomUsePropertyPageRatesEndpoint = 'accom_use_property_page_rates_endpoint',
  isGeneratedTripsEnabled = 'is_generated_trips_enabled',
  marketplacePage = 'marketplace_page',
  carHireBundledDiscount = 'car_hire_bundled_discount',
  lereHeroCarouselEnabled = 'lere_hero_carousel',
  lebtServiceFeesEnabled = 'lebt_service_fees',
  opexHotelAddExtraGuestsEnabled = 'hotel_add_extra_guests',
  croNewMobileMultipleRoom = 'cro_new_mobile_multiple_room',
}
